import { useEffect } from "react";
import { Table, message } from "antd";
import { useRequest } from "ahooks";
import { useLocation } from "react-router-dom";
import { useAuthContext } from "@/components/auth/AuthProvider";
import { addressbook as addressbookService } from "@/services";

function AddressBookPrintTable({ departmentType }) {
  const { state } = useLocation();
  const auth = useAuthContext();

  const {
    data = { total: 0, results: [] },
    loading,
    run,
  } = useRequest(
    (params, token) => {
      return addressbookService.list(params, token);
    },
    {
      manual: true,
      throttleWait: 600,
    }
  );

  useEffect(() => {
    if (auth) {
      run(
        {
          search: state?.keyword,
          page: 1,
          page_size: 100000,
          department__types:
            state?.departmentType === "all" ? undefined : state?.departmentType,
        },
        auth.token
      );
    }
    message.info("请使用快捷键ctrl+p打印列表");
  }, [run, state, auth]);

  const columns = [
    {
      title: "类别",
      key: "types",
      render: (record) => {
        return record.department.types.map((t) => t.name).join(", ");
      },
    },
    {
      title: "名称",
      key: "name",
      render: (record) => record.department.name,
    },
    {
      title: "办公电话",
      key: "office_phone",
      render: (record) => record.department.office_phone,
    },
    {
      title: "负责人",
      key: "director_name",
      render: (record) => record.department.director_name,
    },
    {
      title: "负责人手机",
      key: "director_phone",
      render: (record) => record.department.director_phone,
    },
    {
      title: "联系人",
      dataIndex: "name",
    },
    {
      title: "联系人手机",
      dataIndex: "phone",
    },
    {
      title: "登录账号",
      key: "office_phone",
      render: (record) => record.user?.username,
    },
  ];

  return (
    <div className="table-container">
      <Table
        rowKey="user_id"
        size="middle"
        bordered
        columns={columns}
        dataSource={data.results}
        loading={loading}
        pagination={false}
      />
    </div>
  );
}

export default AddressBookPrintTable;
